









































import gtag from "ga-gtag";
import Vue from "vue";
import FeatureGroup from "../components/FeatureGroup.vue";

export default Vue.extend({
  name: "ProductScoredent",
  metaInfo: {
    title: "Scoredent - Gradebook for teacher",
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: "Scoredent is an application that helps you store and manage student scores. You will no longer have to manually calculate student averages scores." }
    ]
  },
  components: {
    FeatureGroup,
  },
  data() {
    return {
      basicFeatureGroup: [
        {title: "Add classes, student, exam",text: "and easy to manage it"},
        {title: "Add scores",text: "with comments"},
        {title: "Get average score",text: "include percentage and grade letter"},
      ],
      premiumFeatureGroup: [
        {title: "Analyze scores",text: "through statistics and charts", color: "#6a4c93"},
        {title: "Export CSV files",text: "easy to open with Microsoft Excel", color: "#6a4c93"},
        {title: "No ads",text: "annoying ads disappear", color: "#6a4c93"},
      ],
    };
  },
  methods: {
    downloadScoredent() {
      gtag("event", "download", {
        'event_category': "download",
        'event_label': "download_scoredent",
      });
    }
  }
});
